import script from "./dashbMedicAll.vue?vue&type=script&setup=true&lang=js"
export * from "./dashbMedicAll.vue?vue&type=script&setup=true&lang=js"

import "./dashbMedicAll.vue?vue&type=style&index=0&id=c6dd0f2e&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6dd0f2e"]])

export default __exports__